import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listPartnerAgents } from "../actions/partneragentActions";

export default function Partner() {
  const dispatch = useDispatch();

  const partnerAgentList = useSelector((state) => state.partnerAgentList);
  const { partneragents, loading, error } = partnerAgentList;

  useEffect(() => {
    if (partneragents == undefined) {
      dispatch(listPartnerAgents());
    } else if (partneragents.length == 0) {
      dispatch(listPartnerAgents());
    }
  }, [dispatch, partneragents]);
  return (
    <>
      {loading ? (
        <option value="0" key="1">
          Loading...
        </option>
      ) : partneragents ? (
        partneragents.map((countf, index) => (
          <option key={index + 1} value={countf.Partner_Agent_Id}>
            {countf.Partner_Agent}
          </option>
        ))
      ) : (
        <option value="0" key="1">
          {error}
        </option>
      )}
    </>
  );
}
